import { useParams } from "react-router-dom";

export default function useIsOwnProfile() {
  const { id } = useParams();
  return !id;
}
